import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import {
  Button,
} from '@mui/material';

import {setValueAtPathWithOpts} from '~common/form/helper';
import DefinitionSection from '~common/form/definition-section';
import {APIError} from '~common/lib/types';
import ErrorView from '~common/components/error-view';

const styles = (theme: Theme): StyleRules => ({
  buttonBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    spaceBetween: 15,
    padding: 15
  },
  buttonArea: {
    marginTop: 15,
    justifyContent: 'flex-end',
    minHeight: 50
  },
  button: {
    marginLeft: 15
  },
});

interface ActionProps {
  label: any;
  onClick?: Function;
  submit?: boolean;
  variant?: any;
  color?: any;
}

interface Props extends React.HTMLProps<HTMLDivElement> {
  definition: any;
  actions: Array<ActionProps>;
  data?: any;
  formUrl?: string;
  policyMessages?: Array<any>;
  errorText?: string;
  gridSpacing?: any
}

type State = {
  formData?: any;
  error?: any;
  criteria?: any;
};

class ActionForm extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  formRef: any;
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      formData: props.data || {} ,
    };
    
    this.formRef = React.createRef()
  }

  handleChangeAtPath = (path: string, value: any) => {
    var {formData} = this.state;


    let {data, err} = setValueAtPathWithOpts(path, formData, value, {
      emptyAsNull: true
    });

    if (err) {
      const apiErr = new APIError();
      apiErr.message = err;
      this.setState({
        error: apiErr
      });
    } else {
      this.setState({
        criteria: data
      });
    }
  };

  handleActionClick = (action:any) => (evt:any) => {


    const {formData} = this.state;
    // const {onPostResponse} = this.props;

    if(action.onClick) {
        if(evt && evt.preventDefault){
          evt.preventDefault()
        }
        if(evt && evt.stopPropagation){
          evt.stopPropagation()
        }

        action.onClick(formData, evt)
    } else {
      const node = this.formRef.current;
      node.submit()
    }
  }

  renderActionButtons = () => {
    const {actions} = this.props
    const {classes}: {classes: ClassNameMap} = this.props;

    if(actions && actions.length == 0) {
      return null
    }

    return (
          <div className={classes.buttonBar}>
            <div className={classes.buttonArea}>
              {
                actions.map((a:ActionProps, idx:number)=>{
                  return(
                    <Button
                      key={idx}
                      variant="contained"
                      color={a.color || "inherit"}
                      className={classes.buttonr}
                      onClick={this.handleActionClick(a)}>
                      {a.label}
                    </Button>
                  )
                })
              }
            </div>
          </div>
    )

  }

  onErrorClose = () => {
    this.setState({
      error: undefined
    });
  };

  render() {
    // const {classes}: {classes: ClassNameMap} = this.props;
    const {formData, error} = this.state
    const {definition, policyMessages, gridSpacing, formUrl} = this.props

    var errorView;
    if (error) {
      if(typeof(error) !== 'boolean'){
        errorView = (
          <ErrorView classes={{}} error={error} onClose={this.onErrorClose} />
        );
      }
    }


    return (
      <form method="POST" action={formUrl} ref={this.formRef}>
        {errorView}
        <DefinitionSection
          data={formData}
          definition={definition}
          path={''}
          onChangeAtPath={this.handleChangeAtPath}
          policyMessages={policyMessages}
          gridSpacing={gridSpacing || 5}
          suppressTitle
        />
        {this.renderActionButtons()}
      </form>
          
    )
  }
}

export default  withStyles(styles)(ActionForm);


